export type Permission = string;

export interface IPermission {
  value: Permission;
  description: string;
}
